// Module
var code = `<div appHeaderBar>
    <header-bar-title>Welcome to Property Pay</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1
                    tid="welcomeHeader"
                    id="welcomeHeader"
                    class="HOA-container__header-text HOA-container__header-text--blue-light u-textCenter"
            >
                Welcome to Property Pay
            </h1>
        </div>

        <div class="HOA-container__content">
            <p tid="noProfileMessage" class="Field-label u-textCenter">
                We cannot locate your Property Pay Profile under your email address "{{ email }}"
            </p>
            <div class="HOA-container__content-hrule HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100 u-mT5"></div>
            <!-- Option 1: Create a new profile -->
            <div class="HOA-propertylanding__addProperty-marginTop u-textCenter">
                <p id="createProfileText" tid="createProfileText" class="Field-label">
                    If you're new here, click below to create a new profile with Property Pay
                </p>
                <button
                        type="button"
                        tid="createProfileButton"
                        id="createProfileButton"
                        class="Button Button--outline"
                        aria-describedby="createProfileText"
                        (click)="onCreateProfile()">
                    Create a New Property Pay Profile
                </button>
            </div>
            <!-- Option 2: Find an existing profile -->
            <div class="HOA-propertylanding__addProperty-marginTop u-textCenter">
                <p id="findProfileText" tid="findProfileText" class="Field-label">
                    Or search for an existing profile under a different email or phone number
                </p>
                <button
                        type="button"
                        tid="findProfileButton"
                        id="findProfileButton"
                        class="Button Button--outline"
                        aria-describedby="findProfileText"
                        (click)="onFindProfile()">
                    Find Existing Property Pay Profile
                </button>
            </div>

            <div class="HOA-propertylanding__addProperty-marginTop u-textCenter make-sso-decision__guest-payment-hint">
                <div tid="guestPaymentText" class="HOA-font-fine-print">
                    Or make a <strong>guest one-time </strong> payment for
                    <a href="/guest/#/guestpayment" tid="guestPayment" class="u-mB3">
                        assessments
                    </a>
                    or
                    <a href="/guest/#/amenities/guestpayment" tid="guestAmenitiesPayment" class="u-mB3">
                        amenities
                    </a>
                </div>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;